module.exports = __webpack_public_path__ + "img/other3.5a02ff20.png";